module.exports = __webpack_public_path__ + "static/media/chemistry.c6affe4c.gif";